export function normalizeBoardDocumentVideoUrl(url = "") {
  const trimmedUrl = url.trim();

  if (!trimmedUrl) {
    return "";
  }

  const candidateUrl = /^https?:\/\//i.test(trimmedUrl)
    ? trimmedUrl
    : `https://${trimmedUrl}`;

  try {
    const parsedUrl = new URL(candidateUrl);
    const { hostname, pathname, searchParams } = parsedUrl;
    const normalizedHost = hostname.replace(/^www\./, "");

    if (normalizedHost === "youtu.be") {
      const videoId = pathname.replace("/", "");
      return videoId
        ? `https://www.youtube.com/embed/${videoId}`
        : parsedUrl.toString();
    }

    if (normalizedHost === "youtube.com" || normalizedHost === "m.youtube.com") {
      if (pathname.startsWith("/embed/")) {
        return parsedUrl.toString();
      }

      const segments = pathname.split("/").filter(Boolean);
      const videoId =
        searchParams.get("v") ||
        (pathname.startsWith("/shorts/") ? segments[1] : null) ||
        (pathname.startsWith("/live/") ? segments[1] : null);

      if (videoId) {
        return `https://www.youtube.com/embed/${videoId}`;
      }
    }

    if (normalizedHost === "vimeo.com") {
      const videoId = pathname.split("/").filter(Boolean)[0];
      return videoId
        ? `https://player.vimeo.com/video/${videoId}`
        : parsedUrl.toString();
    }

    if (normalizedHost === "loom.com") {
      if (pathname.startsWith("/embed/")) {
        return parsedUrl.toString();
      }

      const segments = pathname.split("/").filter(Boolean);
      const videoId = pathname.startsWith("/share/") ? segments[1] : null;

      if (videoId) {
        return `https://www.loom.com/embed/${videoId}`;
      }
    }

    return parsedUrl.toString();
  } catch (_error) {
    return candidateUrl;
  }
}

export function isDirectBoardDocumentVideoUrl(url = "") {
  if (!url) {
    return false;
  }

  try {
    const parsedUrl = new URL(url);
    const normalizedPath = parsedUrl.pathname.toLowerCase();

    return /\.(mp4|webm|ogg|mov|m4v|m3u8|mpd|ogv)(?:$|\?)/.test(
      normalizedPath
    );
  } catch (_error) {
    return false;
  }
}

export function isSupportedBoardDocumentEmbedUrl(url = "") {
  if (!url) {
    return false;
  }

  try {
    const parsedUrl = new URL(url);
    const normalizedHost = parsedUrl.hostname.replace(/^www\./, "");
    const { pathname } = parsedUrl;

    return (
      (normalizedHost === "youtube.com" && pathname.startsWith("/embed/")) ||
      normalizedHost === "player.vimeo.com" ||
      (normalizedHost === "loom.com" && pathname.startsWith("/embed/"))
    );
  } catch (_error) {
    return false;
  }
}

export function normalizeBoardDocumentContent(html = "") {
  if (!html || typeof document === "undefined") {
    return html;
  }

  const container = document.createElement("div");
  container.innerHTML = html;

  container.querySelectorAll("iframe.ql-video").forEach((iframeNode) => {
    const sourceUrl = normalizeBoardDocumentVideoUrl(
      iframeNode.getAttribute("src") || ""
    );

    if (isDirectBoardDocumentVideoUrl(sourceUrl)) {
      const videoNode = document.createElement("video");
      videoNode.setAttribute("src", sourceUrl);
      videoNode.setAttribute("controls", "controls");
      videoNode.setAttribute("playsinline", "playsinline");
      videoNode.className = "ql-video";

      iframeNode.replaceWith(videoNode);
      return;
    }

    if (isSupportedBoardDocumentEmbedUrl(sourceUrl)) {
      iframeNode.setAttribute("src", sourceUrl);
      return;
    }

    const linkNode = document.createElement("a");
    linkNode.setAttribute("href", sourceUrl);
    linkNode.setAttribute("target", "_blank");
    linkNode.setAttribute("rel", "noopener noreferrer");
    linkNode.textContent = sourceUrl;

    iframeNode.replaceWith(linkNode);
  });

  return container.innerHTML;
}
